module.exports = __webpack_public_path__ + "assets/img/02-f1c1f694.jpg";